<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card>
    <v-card-title>
      <span class="headline">Edit Food Entry</span>
    </v-card-title>

    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-text-field :disabled="true" v-model="food.foodid" label="Food id"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
                :items="sortedTags"
                v-model="food.tags"
                label="Tags"
                item-value="name"
                item-text="name"
                multiple
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="food.fooddescription" :disabled="true" label="Description"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="food.fooddescriptionsimple" label="Description simple" :rules="[rules.required]"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field v-model="food.price" label="Price"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field v-model="food.environmentalimpact" label="Environmental Impact"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-switch v-model="food.local" label="Local"></v-switch>
          </v-flex>
          <v-flex xs6>
            <v-switch v-model="food.organic" label="Organic"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="$emit('update:dialog', false)">Cancel</v-btn>
      <v-btn color="blue darken-1" text @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import FoodService from '@/services/FoodService';
import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      food: {},
      tagsBefore: [],
      rules: {
        required: value => !!value || 'Required.',
      }
    };
  },
  props: {
    editedItem: Object,
    editedIndex: Number
  },
  watch: {
    editedItem: {
      immediate: 'true',
      handler() {
        this.food = Object.assign({}, this.editedItem);
        this.tagsBefore = JSON.parse(JSON.stringify(this.editedItem.tags || []));
      }
    }
  },
  computed: {
    ...mapGetters({
      tags: 'getTags'
    }),
    sortedTags() {
      return this.tags.sort((a, b) => a.name > b.name ? 1 : -1);
    }
  },
  methods: {
    async addTagToFood(tag) {
      try {
        const response = await FoodService.addTagToFood(tag.id, this.food.foodid);
        if (response.status >= 200 && response.status < 400) {
          // this.food.tags = this.food.tags || [];
          // this.food.tags.push(tag.name);
          this.$emit('updateItem', this.editedIndex, this.food);
          this.$emit('snackbar', 'Tag added!', 'blue-grey');
        }
      } catch (e) {
        this.displaySnackbar(e.message, 'error');
      }
    },
    async removeTag(tag) {
      const response = await FoodService.removeTag(tag, this.food.foodid);
      if (response.status >= 200 && response.status < 400) {
        // this.food.tags = this.food.tags.filter((item) => item !== tag);
        this.$emit('updateItem', this.editedIndex, this.food);
        this.$emit('snackbar', 'Tag removed!', 'blue-grey');
      }
    },
    async save() {
      const id = this.food.foodid;
      const params = {
        fooddescriptionsimple: this.food.fooddescriptionsimple,
        price: this.food.price ? parseInt(this.food.price, 10) : null,
        local: this.food.local,
        environmentalimpact: this.food.environmentalimpact ?
            parseInt(this.food.environmentalimpact, 10) : null,
        organic: this.food.organic,
      };
      const response = await FoodService.updateFoodEntry(id, params);
      const originalTags = this.tagsBefore;
      const updatedTags = this.food.tags || [];
      const tagsToAdd = updatedTags.filter(t => !originalTags.includes(t))
      const tagsToRemove = originalTags.filter(t => !updatedTags.includes(t))
      for (const tagName of tagsToRemove) {
        await this.removeTag(tagName);
      }
      for (const tagName of tagsToAdd) {
        const tag = this.tags.find(t => t.name == tagName);
        if (!tag) {
          console.error('could not find tag');
        }else {
          await this.addTagToFood(tag);
        }
      }
      // console.log('tagsToRemove,tagsToAdd',{tagsToRemove,tagsToAdd, tags:this.food.tags, originalTags, updatedTags});
      this.$emit('updateItem', this.editedIndex, this.food);
      this.$emit('update:dialog', false);
      this.$emit('snackbar', 'Ingredient updated!', 'blue-grey');
    },

  }
};
</script>
